
export default function Footer() {
  return (
    <footer className="bg-gradient-to-br from-purple-100 to-purple-200 py-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 mb-12">
          {/* Brand */}
          <div className="text-center md:text-left">
            <h3 className="text-2xl lg:text-3xl font-bold text-purple-800 mb-4 font-pacifico">
              Team Raíssa Bernardo
            </h3>
            <p className="text-purple-600 font-semibold font-poppins leading-relaxed text-sm lg:text-base max-w-xs mx-auto md:mx-0">
              Transformando vidas através do treino inteligente e personalizado. 
              Sua evolução é nossa missão.
            </p>
          </div>
          
          {/* Contact & Social */}
          <div className="text-center md:text-right">
            <div className="flex items-end justify-center md:justify-end gap-6 lg:gap-8">
              {/* Contact */}
              <div className="text-center">
                <h4 className="text-lg lg:text-xl font-semibold text-purple-800 mb-4">
                  Contato
                </h4>
                <a
                  href="https://wa.me/5524992203091"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-16 h-16 lg:w-20 lg:h-20 bg-purple-500 hover:bg-purple-600 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110 cursor-pointer"
                  aria-label="WhatsApp"
                >
                  <i className="ri-whatsapp-line text-2xl lg:text-3xl"></i>
                </a>
              </div>
              
              {/* Social */}
              <div className="text-center">
                <h4 className="text-lg lg:text-xl font-semibold text-purple-800 mb-4">
                  Siga-me
                </h4>
                <a 
                  href="https://www.instagram.com/atleta_raissabernardo?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-16 h-16 lg:w-20 lg:h-20 bg-purple-500 hover:bg-purple-600 text-white rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Instagram"
                >
                  <i className="ri-instagram-line text-2xl lg:text-3xl"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        
        <div className="border-t border-purple-300 pt-8">
          <div className="text-center text-purple-600 font-semibold font-poppins text-sm lg:text-base">
            © 2025 Team Raíssa Bernardo. Todos os direitos reservados.
          </div>
        </div>
      </div>
    </footer>
  );
}
